import { reportError } from "@flow/common/core_routes";
import "@flow/common/webpack_consts";
import "preact/devtools";
import * as React from "react";
import { createRoot } from "react-dom/client";
import "theme/favicon.png";
import "../common/polyfills";
import Root from "./components/Root";
import "./init_styles";

// statically rendered in the ejs template, for performance reasons
declare global {
  const JOURNEY_GUID: string;
  const DEFAULT_LANGUAGE: string;
  const POSTHOG_KEY: string;
  const POSTHOG_HOST: string;
}

function dirty_setup() {
  // force page reload when user edits the URL hash part
  window.onhashchange = location.reload.bind(location);

  window.onerror = function (msg, url, lineNo, columnNo, error) {
    const errorMsg = msg.toString();
    // https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#notes
    // "Script error." means it is an error in a script from a different origin
    // and there isn't much we can do about that.  So we can ignore it and not pollute our error
    // tracking with errors we can't fix.
    if (errorMsg !== "Script error.") {
      reportError.call({
        userAgent: navigator.userAgent,
        msg: errorMsg,
        url: `${url}`,
        lineNo: lineNo === undefined ? 0 : lineNo,
        columnNo: columnNo === undefined ? 0 : columnNo,
        error: `${error?.name}: ${error?.message}`,
      });
    }
    // don't swallow the exception
    return false;
  };
}

function bootstrapReactApp() {
  const rootAppContainer = document.getElementById("app") as HTMLElement;
  const isJourney = rootAppContainer.dataset.isJourney === "true";
  const rootProps = {
    isJourney,
  };

  // ReactDOM.render is deprecated since React 18.0.0, use createRoot instead, see https://reactjs.org/link/switch-to-createroot
  createRoot(rootAppContainer).render(
    <React.StrictMode>
      <Root {...rootProps} />
    </React.StrictMode>
  );
}

window.addEventListener("DOMContentLoaded", (event) => {
  dirty_setup();
  bootstrapReactApp();
});
